import { useQuery } from '@apollo/client'
import { ClientMeQuery } from '__generated__/graphql'
import { ClientMe } from 'client/graphql/client.gql'
import { ReactNode, createContext, useState } from 'react'

export interface IdentityProviderProps {
    children?: ReactNode
}

interface ClientIdentityContextValue {
    client: ClientMeQuery['clientMe'] | null
    refetch: () => void
}

export const ClientIdentityContext = createContext<ClientIdentityContextValue>({
    client: null,
    refetch: () => {},
})

const ClientIdentityProvider: React.FC<IdentityProviderProps> = ({
    children,
}: IdentityProviderProps) => {
    const [identity, setIdentity] = useState<ClientMeQuery['clientMe'] | null>(
        null
    )
    const { refetch: refetchClient } = useQuery(ClientMe, {
        onCompleted: (data) => {
            setIdentity(data.clientMe ?? null)
        },
        onError: (error) => {
            console.error('Error fetching client identity:', error)
            setIdentity(null)
        },
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first',
    })
    return (
        <ClientIdentityContext.Provider
            value={{ client: identity, refetch: refetchClient }}
        >
            {children}
        </ClientIdentityContext.Provider>
    )
}

export default ClientIdentityProvider
